var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import queries from 'constants/queries';
import ApiService from '../ApiService';
import { ClinicReport, DoctorReport, PackageReport } from 'models';
import { plainToClass } from 'class-transformer';
import PatientReport from 'models/entities/reports/PatientReport';
var ReportService = /** @class */ (function (_super) {
    __extends(ReportService, _super);
    function ReportService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootPath = 'reports';
        return _this;
    }
    ReportService.prototype.useClinicReport = function (fromDate, toDate) {
        var _this = this;
        if (fromDate === void 0) { fromDate = ''; }
        if (toDate === void 0) { toDate = ''; }
        return useQuery([queries.reports.clinicReports, fromDate, toDate], function () {
            return _this.get("".concat(_this.rootPath, "/clinics"), __assign(__assign({}, (fromDate ? { from_date: fromDate } : {})), (toDate ? { to_date: toDate } : {})));
        }, {
            select: function (_a) {
                var data = _a.data;
                return plainToClass(ClinicReport, data);
            }
        });
    };
    ReportService.prototype.usePatientReport = function (fromDate, toDate) {
        var _this = this;
        if (fromDate === void 0) { fromDate = ''; }
        if (toDate === void 0) { toDate = ''; }
        return useQuery([queries.reports.patientReports, fromDate, toDate], function () {
            return _this.get("".concat(_this.rootPath, "/patients"), __assign(__assign({}, (fromDate ? { from_date: fromDate } : {})), (toDate ? { to_date: toDate } : {})));
        }, {
            select: function (_a) {
                var data = _a.data;
                return plainToClass(PatientReport, data);
            }
        });
    };
    ReportService.prototype.useDoctorReport = function (fromDate, toDate) {
        var _this = this;
        if (fromDate === void 0) { fromDate = ''; }
        if (toDate === void 0) { toDate = ''; }
        return useQuery([queries.reports.doctorReports, fromDate, toDate], function () {
            return _this.get("".concat(_this.rootPath, "/doctors"), __assign(__assign({}, (fromDate ? { from_date: fromDate } : {})), (toDate ? { to_date: toDate } : {})));
        }, {
            select: function (_a) {
                var data = _a.data;
                return plainToClass(DoctorReport, data);
            }
        });
    };
    ReportService.prototype.usePackageReport = function (fromDate, toDate) {
        var _this = this;
        if (fromDate === void 0) { fromDate = ''; }
        if (toDate === void 0) { toDate = ''; }
        return useQuery([queries.reports.packageReports, fromDate, toDate], function () {
            return _this.get("".concat(_this.rootPath, "/packages"), __assign(__assign({}, (fromDate ? { from_date: fromDate } : {})), (toDate ? { to_date: toDate } : {})));
        }, {
            select: function (_a) {
                var data = _a.data;
                return plainToClass(PackageReport, data);
            }
        });
    };
    ReportService.getInstance = function () {
        if (!ReportService.reportInstance) {
            ReportService.reportInstance = new ReportService();
        }
        return ReportService.reportInstance;
    };
    return ReportService;
}(ApiService));
export default ReportService;
